import React, {Component} from 'react';
import {connect} from 'react-redux';

class TotalMinExposure extends Component {
    getClassName(value) {
        return Number(value) > 100
            ? 'text-dark-red'
            : '';
    }
    render() {
        const {stackNumber, stacking} = this.props;
        const value = stacking.getTotalMinExposureOfCheckedActiveTeamsInStackNumber(stackNumber);

        return (
            <strong className={this.getClassName(value)}>Total min exp: {value}%</strong>
        );
    }
}

function mapStatesToProps(state) {
    const {
        nhlLegacyTeamStacking,
    } = state;

    return {
        stacking: nhlLegacyTeamStacking,
    };
}

export default connect(mapStatesToProps)(TotalMinExposure);
